import { isNumberOnly } from '../validation/isNumberOnly';
import { removeAllDash } from './removeAllDash';
import { removeAllSpace } from './removeAllSpace';

export default function removeDashAndSpaceIfPhoneNumber(contact: string | undefined) {
  const v = removeAllSpace(removeAllDash(contact));
  return v && isNumberOnly(v) ? v : contact;
}
